<template>
  <el-dialog
    title="案件信息"
    :visible.sync="SipShow"
    append-to-body
    :before-close="handleClose"
    width="70%"
  >
    <!--  -->
    <el-tabs
      v-if="caseIdList.length > 0"
      v-model="case_id"
      @tab-click="handleChangeCase"
    >
      <el-tab-pane
        v-for="id in caseIdList"
        :key="id"
        :label="`案件ID：${id}`"
        :name="id"
      ></el-tab-pane>
    </el-tabs>
    <el-row class="fxn-padding-20-0">
      <el-col :span="12"
        >案件详情（案件ID：<span
          class="fxn-text-blue"
          @click="toDetail(CaseInfo.id)"
          style="cursor: pointer;"
          >{{ CaseInfo.id }}</span
        >）查看更多信息点击案件ID</el-col
      >
      <el-col :span="12" class="fxn-text-right">
        <!-- 挂机 -->
        <span class="fxn-margin-r-20" v-if="isseatcalling">
          繁忙中/通话中
          <el-button type="primary" :loading="telLoading" @click="closeTel(1)"
            >挂机</el-button
          >
        </span>
        <span class="fxn-margin-r-20" v-else></span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="6" class="fxn-border-r">
        <div
          class="fxn-ft-18 fxn-text-blue"
          v-if="wsc_encrypt == 0"
          @click="DataMasking"
        >
          {{ CaseInfo.case_name }}
        </div>
        <div class="fxn-ft-18 fxn-text-blue" v-else>
          {{ CaseInfo.case_name }}
        </div>
        <div class="fxn-text-default" v-if="idcard_status">
          {{ CaseInfo.case_phone | mobile }}
        </div>
        <div class="fxn-text-default" v-else>{{ CaseInfo.case_phone }}</div>
      </el-col>
      <el-col :span="6" class="fxn-border-r fxn-padding-l-20">
        <div class="fxn-ft-14">身份证</div>
        <div class="fxn-text-default" v-if="idcard_status">
          {{ CaseInfo.case_idcard | idCardChange }}
        </div>
        <div class="fxn-text-default" v-else>{{ CaseInfo.case_idcard }}</div>
      </el-col>
      <el-col :span="6" class="fxn-border-r fxn-padding-l-20">
        <div class="fxn-ft-14">减免状态</div>
        <div class="fxn-text-default">
          {{ ChangeAgiosStatus(CaseInfo.caseagios_status) }}
        </div>
      </el-col>
      <el-col :span="6" class="fxn-padding-l-20">
        <div class="fxn-ft-14">跟进状态</div>
        <div class="fxn-text-default">
          {{ ChangeCaseStatus(CaseInfo.case_status) }}
        </div>
      </el-col>
    </el-row>

    <div class="fxn-detail-info fxn-border-t fxn-margin-t-20 fxn-padding-t-20">
      <div class="fxn-flex">
        <div class="fxn-flex-item">
          合同编号：<span>{{ CaseInfo.contract }}</span>
        </div>
        <div class="fxn-flex-item fxn-text-blue fxn-font-weight">
          产品名称：{{ CaseInfo.product_name }}
        </div>
        <div class="fxn-flex-item">
          产品类型：<span>{{ CaseInfo.product }}</span>
        </div>
        <div class="fxn-flex-item">
          贷款金额：{{ CaseInfo.loan_money | toThousands }}
        </div>
      </div>
      <div class="fxn-flex">
        <div class="fxn-flex-item fxn-text-red fxn-font-weight">
          逾期天数：{{ CaseInfo.overdue_days }}
        </div>
        <div class="fxn-flex-item fxn-text-blue fxn-font-weight">
          账期：{{ CaseInfo.period }}
        </div>
        <div class="fxn-flex-item">贷款机构：{{ CaseInfo.loan_org }}</div>
        <div class="fxn-flex-item fxn-text-blue fxn-font-weight">
          贷款期数：{{ CaseInfo.periods }}
        </div>
      </div>
      <div class="fxn-flex">
        <div class="fxn-flex-item">
          已还期数：<span>{{ CaseInfo.per_had }}</span>
        </div>
        <div class="fxn-flex-item fxn-text-red fxn-font-weight">
          未还期数：{{ CaseInfo.per_not }}
        </div>
        <div class="fxn-flex-item fxn-text-org fxn-font-weight">
          委托金额：{{ CaseInfo.new_entrust_money | toThousands }}
        </div>
        <div class="fxn-flex-item">
          贷款本金：<span>{{ CaseInfo.loan_capital | toThousands }}</span>
        </div>
      </div>
      <div class="fxn-flex">
        <div class="fxn-flex-item">
          剩余本金：<span>{{ CaseInfo.last_capital | toThousands }}</span>
        </div>
        <div class="fxn-flex-item">
          利息：<span>{{ CaseInfo.interest | toThousands }}</span>
        </div>
        <div class="fxn-flex-item">
          每期还款额：<span>{{ CaseInfo.per_money | toThousands }}</span>
        </div>
        <div class="fxn-flex-item">
          减免后金额：<span>{{
            CaseInfo.agio_money == 0 || CaseInfo.agio_money == ""
              ? "--"
              : CaseInfo.agio_money | toThousands
          }}</span>
        </div>
      </div>
      <div class="fxn-flex">
        <div class="fxn-flex-item">
          已回款金额：<span>{{
            CaseInfo.total_repay_money | toThousands
          }}</span>
        </div>
        <div class="fxn-flex-item">
          应还金额：<span>{{ CaseInfo.amount_payable | toThousands }}</span>
        </div>
        <div class="fxn-flex-item fxn-text-org fxn-font-weight">
          剩余应还：{{ CaseInfo.surplus_amount_payable | toThousands }}
        </div>
        <div class="fxn-flex-item">
          借款日期：<span>{{ CaseInfo.loan_time | dateTime }}</span>
        </div>
      </div>
    </div>
    <!-- Info End -->

    <!-- Remark -->
    <div class="fxn-margin-t-20">
      <div class="fxn-title fxn-border-b">跟进结果（调解记录）</div>
      <div class="fxn-detail-remark">
        <el-form
          :model="RemarkForm"
          :rules="RemarkRules"
          ref="RemarkForm"
          label-width="150px"
        >
          <el-form-item label="案件ID" prop="case_id" style="display: none">
            <el-input
              type="text"
              v-model="RemarkForm.case_id"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_id" style="display: none">
            <el-input
              type="text"
              v-model="RemarkForm.contact_id"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系渠道"
            prop="contact_channel"
            style="display: none"
          >
            <el-input
              type="text"
              v-model="RemarkForm.contact_channel"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="跟进状态" prop="status">
            <el-radio-group v-model="RemarkForm.status" @change="handleStatus">
              <el-radio
                v-for="(item, index) in noteLinkage"
                :key="index"
                :label="index"
                >{{ item.title }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            class="fxn-detail-remark-radio"
            label="调解状态"
            prop="coll_status"
          >
            <el-radio-group
              v-model="RemarkForm.coll_status"
              @change="handleResult(RemarkForm.coll_status, RemarkForm.status)"
              size="mini"
            >
              <el-radio
                border
                v-for="(item, index) in collStatus"
                :key="index"
                :label="index"
                >{{ item.title }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-row>
            <template>
              <div v-for="(list, key) in noteInput" :key="key">
                <el-col :span="8" v-if="list.type == 'time'">
                  <el-form-item :label="list.title" :prop="list.name">
                    <el-date-picker
                      style="width: 100%"
                      v-model="RemarkForm[list.name]"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-else-if="list.type == 'timestamp'">
                  <el-form-item :label="list.title" :prop="list.name">
                    <el-date-picker
                      style="width: 100%"
                      v-model="RemarkForm[list.name]"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-else>
                  <el-form-item :label="list.title" :prop="list.name">
                    <el-input
                      type="text"
                      v-model="RemarkForm[list.name]"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </template>
          </el-row>
          <el-form-item label="沟通内容" prop="notes">
            <el-input
              type="textarea"
              v-model="RemarkForm.notes"
              :rows="5"
              placeholder="请输入沟通内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="loadRemark"
              type="primary"
              @click="SubmitRemark('RemarkForm')"
              >保存调解记录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- Remark End -->

    <div class="fxn-tabs fxn-margin-t-20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="调解记录" name="1"></el-tab-pane>
        <el-tab-pane label="回款记录" name="2"></el-tab-pane>
        <el-tab-pane label="减免记录" name="4"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- Tabs End -->

    <!-- 调解记录 -->
    <div class="fxn-margin-16-0" v-show="activeName == '1'">
      <el-table
        v-loading="loading"
        :data="notes"
        :header-cell-style="{
          background: '#EEEFF4',
          color: '#888888',
          width: '100%',
        }"
      >
        <el-table-column label="催记时间" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.add_time | dateTime("1") }}
          </template>
        </el-table-column>
        <el-table-column label="联络人" align="center">
          <template slot-scope="scope">
            {{ scope.row.contacts_name }}
            ({{ scope.row.relation }})
          </template>
        </el-table-column>
        <el-table-column label="联络方式" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.contacts_phone_all | mobile }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="跟进状态"
          align="center"
          :formatter="ChangeStatus"
        ></el-table-column>
        <el-table-column
          prop="coll_status"
          label="调解状态"
          align="center"
          :formatter="ChangeColl"
        ></el-table-column>
        <el-table-column
          prop="notes"
          label="沟通内容"
          align="center"
        ></el-table-column>
        <el-table-column prop="notes" label="承诺还款信息/备注" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.sms_repay_count">
              <el-button
                class="fxn-text-blue"
                type="text"
                @click="getSmsRepay(scope.row.id)"
                >接收方短信回复</el-button
              >
            </div>
            <span v-else-if="scope.row.status == 2">
              <span v-if="scope.row.coll_status == 1">
                承诺在{{ scope.row.promise_time | dateTime }}前还款{{
                  scope.row.promise_money
                }}元
              </span>
              <span v-else-if="scope.row.coll_status == 3">
                承诺分{{ scope.row.promise_periods }}还款，{{
                  scope.row.promise_per_day
                }}还{{ scope.row.promise_per_money }}”
              </span>
              <span v-else-if="scope.row.coll_status == 4">
                另约{{ scope.row.order_time | dateTime(1) }}进行沟通
              </span>
              <span v-else>--</span>
            </span>
            <span v-else-if="scope.row.status == 8">
              <span v-if="scope.row.repay_status == 2"
                >{{ scope.row.repay_time | dateTime }}部分还款{{
                  scope.row.repay_money
                }}元</span
              >
              <span v-else>--</span>
            </span>
            <span v-else-if="scope.row.status == 9">
              <span v-if="scope.row.repay_status == 2"
                >{{ scope.row.repay_time | dateTime }}结清还款{{
                  scope.row.repay_money
                }}元</span
              >
              <span v-else>--</span>
            </span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="add_name"
          label="调解员"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="contact_channel"
          label="联系渠道"
          align="center"
          :formatter="ChangeChannel"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 调解记录 End -->

    <!-- 回款记录 -->
    <div class="fxn-margin-16-0" v-show="activeName == '2'">
      <div>终审通过还款金额合计：{{ repay_total | toThousands }}元</div>

      <el-table
        v-loading="loading"
        :data="repayments"
        :header-cell-style="{
          background: '#EEEFF4',
          color: '#888888',
          width: '100%',
        }"
      >
        <el-table-column label="登记时间" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.add_time | dateTime("1") }}
          </template>
        </el-table-column>
        <el-table-column label="还款时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.repay_time | dateTime }}
          </template>
        </el-table-column>
        <el-table-column prop="repay_money" label="还款金额" align="center">
          <template slot-scope="{ row }">
            {{ row.repay_money | toThousands }}
          </template>
        </el-table-column>
        <el-table-column
          prop="repay_channel"
          label="还款方式"
          align="center"
        ></el-table-column>
        <el-table-column label="订单号/还款卡号" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.repay_channel == '银联还款'">
              {{ scope.row.repay_account }}
              <span v-if="scope.row.repay_account1"
                >**** {{ scope.row.repay_account1 }}</span
              >
            </span>
            <span v-else>
              {{ scope.row.repay_orderno }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="repay_account_name"
          label="转账人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="repay_status"
          label="还款类型"
          align="center"
          :formatter="changeRepay"
        ></el-table-column>
        <el-table-column label="审核状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.repaystatus != 3">{{
              RepaymentStatus(scope.row.repaystatus, scope.row.hexiao)
            }}</span>
            <el-popover
              v-if="scope.row.repaystatus == 3"
              title="拒绝原因："
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.verify_remark"
            >
              <el-button type="text" slot="reference">{{
                RepaymentStatus(scope.row.repaystatus)
              }}</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="OpenDetail(scope.row.repay_voucher)"
              >查看还款凭证</el-button
            >
            <el-popover
              v-if="scope.row.verify_remark != ''"
              title="查看原因"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="
                VerifyRepay(scope.row.verify_fail) +
                '：' +
                scope.row.verify_remark
              "
            >
              <el-button type="text" slot="reference">查看原因</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 回款记录 End -->

    <!-- 减免记录 -->
    <div class="fxn-margin-16-0" v-show="activeName == '4'">
      <el-table
        v-loading="loading"
        :data="agios"
        :header-cell-style="{
          background: '#EEEFF4',
          color: '#888888',
          width: '100%',
        }"
      >
        <el-table-column label="申请时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.add_time | dateTime("1") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="add_name"
          label="申请人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="申请原因"
          align="center"
        ></el-table-column>
        <el-table-column prop="agio_money" label="减免后金额" align="center">
          <template slot-scope="{ row }">
            {{ row.agio_money | toThousands }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="申请状态"
          align="center"
          :formatter="ChangeAgioStatus"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-popover
              v-if="
                scope.row.verify_remark != '' &&
                (scope.row.status == 3 ||
                  scope.row.status == 5 ||
                  scope.row.status == 6)
              "
              title="查看原因"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="
                VerifyFail(scope.row.verify_fail) +
                '：' +
                scope.row.verify_remark
              "
            >
              <el-button type="text" slot="reference">查看原因</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 减免记录 End -->

    <!-- 查看还款凭证 -->
    <el-dialog title="查看还款凭证" :visible.sync="dialogVisible" width="50%" append-to-body>
      <el-carousel indicator-position="outside">
        <el-carousel-item
          v-for="(item, index) in PayMentImg"
          :key="index"
          class="fxn-text-center"
        >
          <img
            :src="TextUrl + item"
            alt=""
            srcset=""
            style="max-width: 100%; max-height: 100%"
          />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 查看还款凭证 End -->
    <!-- 接收方短信回复 -->
    <SmsRepay :smsRepayObj="smsRepayObj"></SmsRepay>
    <!-- 接收方短信回复 END -->
  </el-dialog>
</template>

<script>
import SmsRepay from "../SmsRepay.vue";
export default {
  components: {
    SmsRepay,
  },
  computed: {
    isseatcalling() {
      return this.$store.getters.iscalling || this.$store.getters.isincall;
    },
  },
  props: {
    wsc_encrypt: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      SipShow: false,
      tipsShow: false,
      case_id: "",
      noteLinkageData: [],
      incallPhone: "",
      caseIdList: [],
      CaseInfo: [],

      telLoading: false,
      idcard_status: true,
      StatusData: [
        { value: 1, label: "待跟进" },
        { value: 2, label: "重点跟进" },
        { value: 3, label: "承诺还款" },
        { value: 4, label: "失联跟进" },
        { value: 5, label: "每日跟进" },
        { value: 6, label: "沟通无果" },
        { value: 7, label: "难联户" },
        { value: 8, label: "部分还款" },
        { value: 9, label: "结清还款" },
        { value: 10, label: "申请发函" },
        { value: 11, label: "发送短信" },
        { value: 12, label: "发送邮件" },
        { value: 99, label: "特殊状态" },
      ],

      //跟进结果
      loadRemark: false,
      RemarkForm: {
        case_id: "",
        status: "2",
        contact_id: "",
        contact_channel: "",
        coll_status: "",
        notes: "",
        order_time: "",
        promise_time: "",
        promise_money: "",
        promise_per_day: "",
        promise_periods: "",
        promise_per_money: "",
      },
      RemarkRules: {
        status: [
          { required: true, message: "请选择跟进状态", trigger: "blur" },
        ],
        coll_status: [
          { required: true, message: "请选择调解状态", trigger: "blur" },
        ],
      },
      noteLinkage: [],
      collStatus: [],
      noteInput: [],

      //Tabs
      loading: false,
      activeName: "1",
      notes: [],
      repayments: [],
      agios: [],
      contactChannel: [],
      CollType: [],

      //回款记录
      repay_total: "",
      tostatus: "",
      reStatus: [],

      //凭证阅览
      PayMentImg: [],
      dialogVisible: false,

      //接收方短信回复
      smsRepayObj: {
        SmsRepayWin: false,
        SmsRepayData: [],
        Smsloading: false,
      },
    };
  },
  methods: {
    opendialog(case_ids, phone) {
      // 若case_ids不是数组，则返回空
      if (!Array.isArray(case_ids) || case_ids.length == 0) {
        return;
      }
      //获取催记状态
      this.noteLinkageData = JSON.parse(sessionStorage.getItem("noteLinkage"));
      this.incallPhone = phone;
      this.caseIdList = case_ids;
      this.case_id = case_ids[0];
      this.getCase();
      this.getContact();
      this.getnoteOp();
      this.getConfigList();
      this.SipShow = true;
    },
    //关闭弹窗
    handleClose() {
      this.SipShow = false;
      if (this.isseatcalling) {
        this.tipsShow = true;
      } else {
        this.tipsShow = false;
      }
    },
    // 切换案件
    handleChangeCase() {
      this.$nextTick(() => {
        this.getCase();
        this.getContact();
      });
    },
    //获取联系人键值
    getContact() {
      this.get("/osapi/Overdue/contacts", {
        is_page: 0,
        case_id: this.case_id,
      }).then((res) => {
        let { msg, code, data } = res.data;
        if (code !== 1) {
          this.$message({
            message: msg,
            type: "error",
          });
        } else {
          //res.data.data[0].id;
          let incallContact = res.data.data.filter((item) => {
            return item.contacts_phone == this.incallPhone;
          });
          this.RemarkForm.contact_id = incallContact[0].id;
        }
      });
    },
    //跳转详情
    toDetail(id) {
      this.$router.push({ 
        path: '/CaseDetail/' + id, 
        query: {
          id: id,
          noncollector: true
        } 
      })
      // this.$router.push({
      //   path: "/CaseInfo/" + id,
      //   query: {
      //     id: id,
      //     listId: 0,
      //     callshow: true,
      //     detailtype: true,
      //   },
      // });
      this.SipShow = false;
    },

    //挂机
    closeTel(type) {
      webrtcSDK.endCall();
    },

    //数据脱敏
    DataMasking() {
      this.idcard_status = !this.idcard_status;
    },

    //减免状态
    ChangeAgiosStatus(status) {
      if (status == 0) {
        return "未申请";
      } else if (status == 1) {
        return "待审核";
      } else if (status == 2) {
        return "已减免";
      } else if (status == 3) {
        return "审核未通过";
      } else if (status == 4) {
        return "待终审";
      }
    },

    //跟进状态
    ChangeCaseStatus(case_status) {
      for (let index = 0; index < this.StatusData.length; index++) {
        if (parseInt(case_status) == this.StatusData[index].value) {
          return this.StatusData[index].label;
        }
      }
    },

    //选择跟进状态
    handleStatus() {
      this.collStatus = [];
      this.noteInput = [];
      this.RemarkForm.notes = "";
      for (var key in this.noteLinkage) {
        if (key === this.RemarkForm.status) {
          this.collStatus = this.noteLinkage[key].sub;
          break;
        }
      }
      this.RemarkForm.coll_status = "";
      for (var collKey in this.collStatus) {
        if (collKey === key) {
          this.noteInput = this.collStatus[collKey].sub;
          break;
        }
      }
    },

    //选择调解状态
    handleResult(status) {
      this.noteInput = [];
      for (var collKey in this.collStatus) {
        if (collKey === this.RemarkForm.coll_status) {
          this.noteInput = this.collStatus[collKey].sub;
          break;
        }
      }
      //失联跟进状态默认给催记内容覆值
      if (status == 4) {
        for (let collkey in this.collStatus) {
          if (this.RemarkForm.coll_status == collkey) {
            this.RemarkForm.notes = this.collStatus[collkey]["title"];
          }
        }
      }
    },

    //获取催记状态
    getnoteOp() {
      this.get("/osapi/overdue/noteOp").then((res) => {
        let { code, msg, data } = res.data;
        if (code != 1) {
          this.$message({
            message: msg,
            type: "error",
          });
        } else {
          this.noteLinkage = res.data.data.noteLinkage;
          this.handleStatus();
          this.handleResult();
        }
      });
    },

    //提交跟进状态
    SubmitRemark(formName) {
      let numbers = /^[1-9]\d*$/;
      let twonumber =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.RemarkForm.coll_status == 1) {
            if (!this.RemarkForm.promise_time) {
              this.$message({
                message: "请选择承诺还款时间",
                type: "error",
              });
              return;
            }
            if (this.RemarkForm.promise_money == "") {
              this.$message({
                message: "请输入承诺还款金额",
                type: "error",
              });
              return;
            } else if (!twonumber.test(this.RemarkForm.promise_money)) {
              this.$message({
                message: "承诺还款金额格式不正式;如25000",
                type: "error",
              });
              return;
            }
          }

          if (this.RemarkForm.coll_status == 3) {
            if (!this.RemarkForm.promise_periods) {
              this.$message({
                message: "请输入承诺分期数",
                type: "error",
              });
              return;
            } else if (!numbers.test(this.RemarkForm.promise_periods)) {
              this.$message({
                message: "承诺分期数格式不正确;如:20",
                type: "error",
              });
              return;
            }
            if (!this.RemarkForm.promise_per_money) {
              this.$message({
                message: "请输入承诺每期还款金额",
                type: "error",
              });
              return;
            } else if (!twonumber.test(this.RemarkForm.promise_periods)) {
              this.$message({
                message: "承诺每期还款金额格式不正确;如:20.00",
                type: "error",
              });
              return;
            }
            if (!this.RemarkForm.promise_per_day) {
              this.$message({
                message: "请输入承诺每期还款日期",
                type: "error",
              });
              return;
            } else if (!numbers.test(this.RemarkForm.promise_per_day)) {
              this.$message({
                message: "承诺每期还款日期格式不正确;如:20",
                type: "error",
              });
              return;
            }
          }

          if (this.RemarkForm.coll_status == 4) {
            if (!this.RemarkForm.order_time) {
              this.$message({
                message: "请选择另约时间",
                type: "error",
              });
              return;
            }
          }

          this.loadRemark = true;

          this.post("/osapi/Overdue/noteOp", {
            case_id: this.case_id,
            contact_id: this.RemarkForm.contact_id,
            status:
              this.RemarkForm.status == "1" ? "5" : this.RemarkForm.status,
            coll_status: this.RemarkForm.coll_status,
            notes: this.RemarkForm.notes,
            promise_time: this.RemarkForm.promise_time,
            promise_money: this.RemarkForm.promise_money,
            promise_periods: this.RemarkForm.promise_periods,
            promise_per_money: this.RemarkForm.promise_per_money,
            promise_per_day: this.RemarkForm.promise_per_day,
            order_time: this.RemarkForm.order_time,
            contact_channel: this.RemarkForm.contact_channel,
          }).then((res) => {
            let { msg, code, data } = res.data;
            if (code !== 1) {
              this.$message({
                message: msg,
                type: "error",
              });
            } else {
              this.$message({
                message: "提交成功!",
                type: "success",
              });
              this.noteInput = [];
              this.RemarkForm.notes = "";
              this.RemarkForm.coll_status = "";
              this.RemarkForm.order_time = "";
              this.RemarkForm.promise_time = "";
              this.RemarkForm.promise_money = "";
              this.RemarkForm.promise_per_day = "";
              this.RemarkForm.promise_periods = "";
              this.RemarkForm.promise_per_money = "";
              this.getWorks();
            }
          }).finally(() => {
            this.loadRemark = false;
          });
        }
      });
    },

    // 记录tab
    handleClick() {
      this.getWorks();
    },

    //选择回款记录
    onRepay() {
      this.getWorks(this.tostatus);
    },

    //获取Tabs
    getWorks(status) {
      this.loading = true;
      this.get("/osapi/Cases/caseWork", {
        case_id: this.case_id,
        work_type: this.activeName,
        status: status,
      }).then((res) => {
        let { code, msg, data } = res.data;
        if (code != 1) {
          this.$message({
            message: msg,
            type: "error",
          });
        } else {
          this.notes = res.data.data.notes;
          this.repayments = res.data.data.repayments;
          this.agios = res.data.data.agios;
          this.repay_total = res.data.data.repay_total;
        }
        this.loading = false;
      });
    },

    //接收方短信回复
    getSmsRepay(id) {
      this.get("/osapi/Cases/getCaseNotesSmsRepay", {
        note_id: id,
      }).then((res) => {
        let { code, msg, data } = res.data;
        if (code != 1) {
          this.$message({
            type: "error",
            message: msg,
          });
          this.smsRepayObj.Smsloading = false;
        } else {
          this.smsRepayObj.SmsRepayWin = true;
          this.smsRepayObj.SmsRepayData = res.data.data.sms_repay_list;
          this.smsRepayObj.Smsloading = false;
        }
      });
    },

    //获取渠道
    getConfigList() {
      this.get("/osapi/Config/confList").then((res) => {
        let { msg, code, data } = res.data;
        if (code !== 1) {
          this.$message({
            message: msg,
            type: "error",
          });
        } else {
          this.contactChannel = res.data.data;
          for (let key = 0; key < this.contactChannel.length; key++) {
            if (this.contactChannel[key].title == "电话") {
              this.RemarkForm.contact_channel = this.contactChannel[key].id;
            }
          }
          if (this.contactChannel.length < 1) {
            this.$message({
              message: "请先添加联系渠道!",
              type: "error",
            });
            return false;
          }
        }
      });
    },

    //获取详情
    getCase() {
      this.get("/osapi/Cases/caseInfo", {
        id: this.case_id,
      }).then((res) => {
        let { msg, code, data } = res.data;
        if (code != 1) {
          this.$message({
            message: msg,
            type: "error",
          });
        } else {
          this.CaseInfo = res.data.data.data;
          this.getWorks();
        }
      });
    },

    //跟进状态
    ChangeStatus(row) {
      for (let index = 0; index < this.StatusData.length; index++) {
        if (row.status == this.StatusData[index].value) {
          return this.StatusData[index].label;
        }
      }
    },

    //调解状态
    ChangeColl(row) {
      if (row.is_import == 1) {
        return row.coll_status_title;
      } else {
        for (let key in this.noteLinkageData) {
          if (row.coll_status == key) {
            return this.noteLinkageData[key];
          }
        }
      }
    },

    //联系渠道
    ChangeChannel(row) {
      for (let key in this.contactChannel) {
        if (row.contact_channel == this.contactChannel[key].id) {
          return this.contactChannel[key].title;
        }
      }
    },
    //还款类型
    changeRepay(row) {
      switch (parseInt(row.repay_status)) {
        case 8:
          return "部分还款";
        case 9:
          return "结清还款";
      }
    },
    //回款记录--审核状态
    RepaymentStatus(repaystatus, hexiao) {
      if (repaystatus == 1) {
        return "待审核";
      } else if (repaystatus == 2) {
        if (hexiao == 1) {
          return "核销通过";
        } else {
          return "已通过";
        }
      } else if (repaystatus == 3) {
        return "初审不通过";
      } else if (repaystatus == 4) {
        return "初审通过";
      } else if (repaystatus == 5) {
        return "终审不通过";
      } else if (repaystatus == 6) {
        return "已撤销";
      }
    },
    //查看
    OpenDetail(repay_voucher) {
      this.dialogVisible = true;
      this.PayMentImg = repay_voucher.split(",");
    },
    //回款拒绝原因
    VerifyRepay(type) {
      if (type == 1) {
        return "无凭证";
      } else if (type == 2) {
        return "凭证错误";
      } else if (type == 3) {
        return "未收到";
      }
    },

    //减免状态
    ChangeAgioStatus(row) {
      switch (parseInt(row.status)) {
        case 1:
          return "未处理";
        case 2:
          return "通过";
        case 3:
          return "拒绝";
        case 4:
          return "待终审";
        case 5:
          return "拒绝";
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/AiSip/InCallDialog.vue